import React, { useEffect, useState } from "react";
import { FaChevronRight } from "react-icons/fa";
import { Box, Image, Stack, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

export default function JewelleryCard({
  products,
  images = [],
  price,
  title,
  props,
}) {
  const navigate = useNavigate();
  const [currentImage, setCurrentImage] = useState(0);
  useEffect(() => {
    if (images.length > 1) {
      const interval = setInterval(() => {
        setCurrentImage((prev) => (prev + 1) % images.length);
      }, 2000); // change image every 2 seconds
      return () => clearInterval(interval);
    }
  }, [images]);
  return (
    <Box
      className="group"
      bg="#FCFBF9"
      h="full"
      p={6}
      pr={2}
      cursor="pointer"
      display="flex"
      flexDirection="row"
      {...props}
      onClick={() => navigate("/product/" + products?._id)}
    >
      <Stack flex={1}>
        <Stack flex={1} justify="center" align="center">
          <Image
            src={images?.[currentImage]}
            transition="all 0.3s ease-in-out"
            _groupHover={{
              filter: "brightness(1.05)",
              boxShadow: "lg",
              
            }}
          />
        </Stack>

        <>
          <Text>{title}</Text>
          <Text>₹{price}</Text>
        </>
      </Stack>

      <Box
        my="auto"
        opacity={0}
        _groupHover={{ opacity: 1 }}
        transition="opacity 0.3s ease"
      >
        <FaChevronRight />
      </Box>
    </Box>
  );
}
